import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { MissionService, MissionType } from "../generated";
import DOMPurify from "dompurify";

export class GetStarted extends Component<
  RouteComponentProps,
  { loading: boolean }
> {
  constructor(props: RouteComponentProps) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    const rawCode = new URLSearchParams(this.props.location.search).get("code");
    const sanitizedCode = DOMPurify.sanitize(rawCode);

    const data = await MissionService.missionType({
      code: sanitizedCode,
    });

    if (data.type === "Accounts") {
      window.location.href = "/accounts/start" + this.getSearchParams();
    } else if (data.type === "Payments" || data.type === "BulkPayments") {
      window.location.href = "/payments/start" + this.getSearchParams();
    } else if (data.type === MissionType.VRPCONSENT) {
      window.location.href = "/vrps/start" + this.getSearchParams();
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  getSearchParams = (): string => {
    const searchParams = new URLSearchParams(this.props.location.search);
    const validatedParams: string[] = [];

    searchParams.forEach((value, key) => {
      const validatedValue = encodeURIComponent(value);
      validatedParams.push(`${key}=${validatedValue}`);
    });

    const validatedSearch = `?${validatedParams.join("&")}`;
    return validatedSearch;
  };

  render() {
    if (this.state.loading) return <p>Loading, please wait... </p>;

    return (
      <div>
        <h2>Error</h2>
        <br />
        <p>The provided link did not work.</p>
      </div>
    );
  }
}
